import React from "react";
import { Button, Modal, Form, Input, Switch, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createFeatures } from "../../redux/Features/FeaturesActions";

const AddModal = ({ isModalOpen, setIsModalOpen, onSuccess }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const usertoken = useSelector((state) => state.Auth.token);
  const userData = useSelector((state) => state.Auth.userData);

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const submitHandler = (values) => {
    const data = {
      _id: userData?._id,
      title: values.name,
      status: values.status,
    };

    try {
      dispatch(createFeatures(data, usertoken, onSuccess));
      form.resetFields();
      setIsModalOpen(false);
    } catch (error) {
      message.error("Failed to create Permission. Please try again.");
    }
  };

  return (
    <Modal
      footer={null}
      title="Create Permission"
      open={isModalOpen}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        name="createFeature"
        onFinish={submitHandler}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          status: true,
        }}
      >
        <Form.Item
          label="Permission Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter the Permission name!",
            },
          ]}
        >
          <Input placeholder="Enter Permission name" />
        </Form.Item>

        <Form.Item label="Status" name="status" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
